// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__srzwP","footer":"ModalInfo_footer__1KfEA"};